import React from "react";
import { Carousel } from "react-bootstrap";

export default class ProductImageCarousel extends React.Component {
  static fixEmptyProductImage(image) {
    return image !== undefined ? image.high : "";
  }

  constructor(props) {
    super(props);

    this.state = {
      productImages: this.props.product.images,
    };
  }

  render() {
    const showControls = this.state.productImages.length > 1;

    return (
      <Carousel
        interval={0}
        className="productCarousel"
        controls={showControls}
        indicators={showControls}
      >
        {this.state.productImages.map((productImage, i) => (
          <Carousel.Item key={i}>
            <img
              src={ProductImageCarousel.fixEmptyProductImage(productImage)}
              className="product-detail-image"
              alt=""
            />
          </Carousel.Item>
        ))}
      </Carousel>
    );
  }
}
